module.exports = __webpack_public_path__ + "img/wave-2.4152d82d.svg";